export const LBP_START_PARTICIPATION = "Thu Apr 22 2021 13:00:00 UTC+00";
export const LBP_END_PARTICIPATION = "Thu Apr 23 2021 13:00:00 UTC+00";

export const AIRDROP_START_PARTICIPATION = "Thu Apr 23 2021 13:00:00 UTC+00";

export const AIRDROP_END_PARTICIPATION = "Tue Jun 01 2021 13:00:00 UTC+00";

export const DAY_IN_MILISECONDS = 86400000
